(function () {
  var STORAGE_KEY = 'vgf_recently_viewed';
  var MAX_STORED = 20;

  function getStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setStored(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage unavailable (private browsing, etc) - fail silently */
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function resizeImage(url) {
    if (!url) return url;
    return url.replace(/\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i, '_400x.$1$2');
  }

  function renderProduct(list, product) {
    var li = document.createElement('li');
    li.className = 'vgf-recently-viewed__item grid__item';

    var wrapper = document.createElement('div');
    wrapper.className = 'card-wrapper product-card-wrapper underline-links-hover';

    var card = document.createElement('div');
    card.className = 'card card--standard card--media';

    var cardInner = document.createElement('div');
    cardInner.className = 'card__inner ratio';

    var link = document.createElement('a');
    link.href = product.url;
    link.className = 'full-unstyled-link';

    var media = document.createElement('div');
    media.className = 'card__media';
    var mediaInner = document.createElement('div');
    mediaInner.className = 'media media--transparent media--hover-effect';

    if (product.featured_image) {
      var img = document.createElement('img');
      img.src = resizeImage(product.featured_image);
      img.loading = 'lazy';
      img.alt = product.title || '';
      mediaInner.appendChild(img);
    }
    media.appendChild(mediaInner);
    cardInner.appendChild(media);
    link.appendChild(cardInner);
    card.appendChild(link);

    var content = document.createElement('div');
    content.className = 'card__content';
    var information = document.createElement('div');
    information.className = 'card__information';

    var heading = document.createElement('h3');
    heading.className = 'card__heading h5';
    var headingLink = document.createElement('a');
    headingLink.href = product.url;
    headingLink.className = 'full-unstyled-link';
    headingLink.textContent = product.title;
    heading.appendChild(headingLink);
    information.appendChild(heading);

    var price = document.createElement('div');
    price.className = 'price';
    var priceItem = document.createElement('span');
    priceItem.className = 'price-item price-item--regular';
    priceItem.textContent = formatMoney(product.price);
    price.appendChild(priceItem);
    information.appendChild(price);

    content.appendChild(information);
    card.appendChild(content);
    wrapper.appendChild(card);
    li.appendChild(wrapper);
    list.appendChild(li);
  }

  function init(root) {
    var currentHandle = root.getAttribute('data-current-handle');
    var maxShow = parseInt(root.getAttribute('data-max-show'), 10) || 4;
    var list = root.querySelector('.vgf-recently-viewed__list');
    var stored = getStored();
    var toShow = stored.filter(function (handle) {
      return handle && handle !== currentHandle;
    }).slice(0, maxShow);

    if (list && toShow.length > 0) {
      Promise.all(
        toShow.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (response) { return response.ok ? response.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        products.forEach(function (product) {
          if (product) renderProduct(list, product);
        });
        if (list.children.length > 0) {
          root.style.removeProperty('display');
        }
      });
    }

    var updatedHandles = [currentHandle].concat(
      stored.filter(function (handle) { return handle !== currentHandle; })
    );
    setStored(updatedHandles);
  }

  document.querySelectorAll('.vgf-recently-viewed').forEach(init);
})();
